/*
  The delivery promise, in the browser: one late date and the seasonal "order by"
  switch (Christmas, then Valentine's Day). Bible ch. 16 s4 points 2-3.

  This is the same arithmetic as `traceform/delivery.py`, which is the one that the
  delay-notice rules are judged against; `tests/orders/test_delivery.py` runs both
  on the same dates and fails when they part. Weekends are skipped, holidays are
  not -- a holiday can only make the real date later than this says, and a promise
  that is later than the arithmetic is the direction to be wrong in.

  The values come in as a config object (`lead_business_days`, and `seasons`, each
  with `name`, `banner_from`, `holiday` and `cutoffs` keyed by market, dates as
  `YYYY-MM-DD`) so the theme inlines `config/delivery.json` rather than keeping a
  second copy of the numbers. The banner carries one `data-before-<name>` and
  `data-after-<name>` text per season.
  Dates are handled as UTC calendar days throughout; `today` is the customer's
  local calendar day, passed in as a Date.
*/
(function () {
  'use strict';

  function utcDay(d) {
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  }

  function parseDay(iso) {
    var p = iso.split('-');
    return new Date(Date.UTC(Number(p[0]), Number(p[1]) - 1, Number(p[2])));
  }

  function businessDaysAfter(day, days) {
    var out = new Date(day.getTime());
    var remaining = days;
    while (remaining) {
      out.setUTCDate(out.getUTCDate() + 1);
      if (out.getUTCDay() !== 0 && out.getUTCDay() !== 6) remaining -= 1;
    }
    return out;
  }

  function arrivesBy(today, config) {
    return businessDaysAfter(utcDay(today), config.lead_business_days);
  }

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];

  function formatDay(day) {
    return MONTHS[day.getUTCMonth()] + ' ' + day.getUTCDate();
  }

  function arrivesByLine(today, config, audience) {
    return (audience === 'gift' ? 'Made for them.' : 'Made for you.') + ' Arrives by ' + formatDay(arrivesBy(today, config)) + '.';
  }

  function activeSeason(today, config) {
    var day = utcDay(today).getTime();
    for (var i = 0; i < config.seasons.length; i += 1) {
      var season = config.seasons[i];
      if (day >= parseDay(season.banner_from).getTime() && day <= parseDay(season.holiday).getTime()) {
        return season;
      }
    }
    return null;
  }

  function orderByState(today, market, config) {
    var season = activeSeason(today, config);
    if (!season) return 'hidden';
    return utcDay(today).getTime() <= parseDay(season.cutoffs[market]).getTime() ? 'before' : 'after';
  }

  window.TraceformDelivery = {
    arrivesBy: arrivesBy,
    arrivesByLine: arrivesByLine,
    activeSeason: activeSeason,
    orderByState: orderByState
  };

  // The page wiring. Every `[data-delivery-line]` gets today's promised date in its
  // `<time>` and is unhidden; the `[data-order-by]` banner gets the state its
  // market is in. Nothing here runs under the node twin (no `document` there), so
  // the arithmetic above stays testable on its own.
  if (typeof document === 'undefined') return;

  function init() {
    var node = document.getElementById('traceform-delivery-config');
    if (!node) return;
    var config = JSON.parse(node.textContent);
    var today = new Date();
    var arrival = arrivesBy(today, config);
    var lines = document.querySelectorAll('[data-delivery-line]');
    for (var i = 0; i < lines.length; i += 1) {
      var time = lines[i].querySelector('[data-delivery-date]');
      if (!time) continue;
      time.textContent = formatDay(arrival);
      time.setAttribute('datetime', arrival.toISOString().slice(0, 10));
      lines[i].hidden = false;
    }
    document.querySelectorAll('[data-order-by]').forEach(function (banner) {
      var market = banner.getAttribute('data-market') || 'US';
      var state = orderByState(today, market, config);
      if (state === 'hidden') {
        banner.hidden = true;
        return;
      }
      var season = activeSeason(today, config);
      var cutoff = parseDay(season.cutoffs[market]);
      var text = banner.getAttribute('data-' + state + '-' + season.name) || '';
      var days = Math.round((cutoff.getTime() - utcDay(today).getTime()) / 86400000);
      if (state === 'before' && days >= 0 && days <= 14) {
        var countdown = banner.getAttribute(days === 1 ? 'data-day-left' : 'data-days-left');
        if (countdown) text += ' ' + countdown.replace('{days}', days);
      }
      banner.textContent = text.replace('{date}', formatDay(cutoff));
      banner.setAttribute('data-state', state);
      banner.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
